// src/components/TimelineToggle.js

import React from "react";

const GridIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{flexShrink:0}}>
    <rect x="0" y="0" width="6" height="6" rx="1.5" fill="currentColor" opacity=".7"/>
    <rect x="8" y="0" width="6" height="6" rx="1.5" fill="currentColor" opacity=".7"/>
    <rect x="0" y="8" width="6" height="6" rx="1.5" fill="currentColor" opacity=".7"/>
    <rect x="8" y="8" width="6" height="6" rx="1.5" fill="currentColor" opacity=".7"/>
  </svg>
);

const TimelineIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{flexShrink:0}}>
    <circle cx="3" cy="3" r="2" fill="currentColor" opacity=".7"/>
    <rect x="7" y="2" width="7" height="2" rx="1" fill="currentColor" opacity=".5"/>
    <circle cx="3" cy="7" r="2" fill="currentColor" opacity=".7"/>
    <rect x="7" y="6" width="7" height="2" rx="1" fill="currentColor" opacity=".5"/>
    <circle cx="3" cy="11" r="2" fill="currentColor" opacity=".7"/>
    <rect x="7" y="10" width="7" height="2" rx="1" fill="currentColor" opacity=".5"/>
  </svg>
);

const TimelineToggle = ({ view, onChange }) => (
  <div className="tl-toggle">
    <button
      className={`tl-toggle__btn${view === "grid" ? " tl-toggle__btn--active" : ""}`}
      onClick={() => onChange("grid")}
      title="Grid view"
    >
      <GridIcon /> Grid
    </button>
    <button
      className={`tl-toggle__btn${view === "timeline" ? " tl-toggle__btn--active" : ""}`}
      onClick={() => onChange("timeline")}
      title="Timeline view"
    >
      <TimelineIcon /> Timeline
    </button>
  </div>
);

export default TimelineToggle;